import { createAction } from "@reduxjs/toolkit";
import { Post } from "src/types/post";

export const POSTS_GET_ALL = createAction<{ posts: Post[] }>("@posts/GET_ALL");
export const POSTS_ADD = createAction<{ post: Post }>("@posts/ADD");
export const POSTS_DELETE = createAction<{ postId: string }>("@posts/DELETE");
export const POSTS_UPDATE = createAction<{ post: Post }>("@posts/UPDATE");

